import isMobile from './is-mobile.js';

$(".js-categoryLink-header").on("click", function(){
  $(this).closest(".js-categoryLink").toggleClass("is-categoryLink--show");

});
